/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HFlow, Text, VFlow } from 'bold-ui'
import { SimNaoEnum } from 'components/form'
import { MetaPath } from 'util/metaPath'

import { ConsultaSeguimentoOutroFieldModel, PassouFalhouEnum } from '../model-consultaSeguimento'
import { ExemplosHorizontalColumnField, ExemplosHorizontalColumnFieldComponents } from './ExemplosHorizontalColumnField'
import { ExemplosHorizontalFieldIndicatorFalhou } from './ExemplosHorizontalFieldIndicatorFalhou'
import { ExemplosHorizontalFieldIndicatorPassou } from './ExemplosHorizontalFieldIndicatorPassou'

export type ExemplosHorizontalFieldModel<T extends string> = Record<PassouFalhouEnum, Record<T, SimNaoEnum>>

export type ExemplosHorizontalFieldOptions<T extends string> = Record<
  PassouFalhouEnum,
  Array<{ value: T; label: string }>
>

interface ExemplosHorizontalFieldProps<T extends string> {
  name: MetaPath<ExemplosHorizontalFieldModel<T>>
  nameOutro: MetaPath<ConsultaSeguimentoOutroFieldModel>
  label: string
  options: ExemplosHorizontalFieldOptions<T>
  components?: Partial<Record<PassouFalhouEnum, ExemplosHorizontalColumnFieldComponents>>
  showIndicator?: PassouFalhouEnum | null
  showTagOptional?: Partial<Record<PassouFalhouEnum, boolean>>
}

export function ExemplosHorizontalField<T extends string>(props: Readonly<ExemplosHorizontalFieldProps<T>>) {
  const { name, nameOutro, label, options, components, showIndicator, showTagOptional } = props

  return (
    <VFlow vSpacing={0.5}>
      <Text fontWeight='bold'>{label}</Text>
      <VFlow vSpacing={0}>
        <HFlow hSpacing={0.5} style={styles.hFlow}>
          <ExemplosHorizontalColumnField
            name={name.PASSOU}
            nameOutro={nameOutro}
            label='Exemplos Passou'
            options={options.PASSOU}
            required
            components={components?.PASSOU}
            showIndicator={showIndicator === PassouFalhouEnum.PASSOU}
            showTagOptional={showTagOptional?.PASSOU}
          />
          <ExemplosHorizontalColumnField
            name={name.FALHOU}
            nameOutro={nameOutro}
            label='Exemplos Falhou'
            options={options.FALHOU}
            required
            components={components?.FALHOU}
            showIndicator={showIndicator === PassouFalhouEnum.FALHOU}
            showTagOptional={showTagOptional?.FALHOU}
            showOutroField
          />
        </HFlow>
        {showIndicator === PassouFalhouEnum.PASSOU && <ExemplosHorizontalFieldIndicatorPassou />}
        {showIndicator === PassouFalhouEnum.FALHOU && (
          <ExemplosHorizontalFieldIndicatorFalhou style={styles.indicatorFalhou} />
        )}
      </VFlow>
    </VFlow>
  )
}

const styles = {
  hFlow: css`
    grid-template-columns: 1fr 1fr;
  `,
  indicatorFalhou: css`
    margin-left: calc(50% - 1px);
  `,
}
